var map = {
	"./1-disabled.png": "769d",
	"./2-disabled.png": "7353",
	"./3-disabled.png": "4d5d",
	"./4-disabled.png": "b2f0",
	"./5-disabled.png": "47c4",
	"./6-disabled.png": "46f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3baf";